import { Context, createContext, useContext } from 'react';
import { IListClient } from '../constants';

interface IClientListContext {
  listIds: Array<IListClient['business_client_uuid']>;
  listData: Record<IListClient['business_client_uuid'], IListClient>;
  onOpenEditClientModal(clientUuid: string): void;
  onOpenDeleteClientModal(clientUuid: string): void;
  onCreateInvoice(clientUuid: string): void;
}

export const ClientListContext: Context<IClientListContext> = createContext(
  {} as IClientListContext,
);

export function useClientListContext() {
  const contextData = useContext(ClientListContext);
  return contextData;
}
